import React, { useContext } from "react";
import { UserContext } from "../userContext";
import { db, auth } from "../firebase";
import logo from '../assets/egram.svg';


const Navbar = () => {
  const { user } = useContext(UserContext).user;
  const Logout = () => {
    auth
      .signOut()
      .then(() => {
        localStorage.removeItem("egram-user");
        db.collection("users").doc(user.email).update({
          isOnline: false,
        });
      })
      .catch((error) => {
        console.log("Some Error Occured.", error.message);
      });
    window.location.reload();
  };

  return (
    <div className="navbar">
      <div className="navbar__brand">
        <img className="logo" src={logo} alt="egram-logo" /> <h1>eGram </h1>
      </div>

      {user && (
        <div className="navbar__user">
          <button className="navbar__logout" onClick={Logout}>
            Logout
          </button>
          <img className="navbar__pic" src={user.photoURL} alt="user profile" />
        </div>
      )}
    </div>
  );
};

export default Navbar;
